module.exports = __webpack_public_path__ + "static/img/ikonaNotatkaDisabled-OFF.bb9bfc8d.png";